export const parseFundsReportBlobError = async (err) => {
  const data = err?.response?.data;
  if (data instanceof Blob) {
    try {
      const parsed = JSON.parse(await data.text());
      return parsed?.message || null;
    } catch {
      return null;
    }
  }

  return data?.message || null;
};

export const fileNameFromDisposition = (headers, fallback) => {
  const disposition =
    headers?.["content-disposition"] || headers?.["Content-Disposition"];
  if (!disposition) {
    return fallback;
  }

  const utfMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utfMatch?.[1]) {
    try {
      return decodeURIComponent(utfMatch[1].trim());
    } catch {
      return utfMatch[1].trim();
    }
  }

  const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
  if (match?.[1]) {
    return match[1].replace(/['"]/g, "").trim();
  }

  return fallback;
};
